import courierConfigService from "../api/server/courierConfigService";
import errorHelper from "@/components/helpers/errorhelper";
export const COURIER_CONFIG_NAMESPACE = "courierConfigModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/courierConfigService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(courierConfigService)
};

const state = {
  loading: true,
  apiconnection: null,
  selected: {},
  couriers: []
};
const actions = {
  clearApiConnection(context) {
    context.commit("clearApi");
  },
  setSelected(context, data) {
    context.commit("selectCourier", data);
  },
  async getServices(context, data) {
    var api = await services.api;
    return api
      .getServices(data.user, data.pass, data.endpoint)
      .then(function(value) {
        context.commit("loadServices", value);
      })
      .catch(
        /* istanbul ignore next */ function() {
          context.commit("setError", false);
        }
      );
  },
  async saveCourier(context, data) {
    var api = await services.api;
    return api
      .saveCourier(data)
      .then(function(value) {
        if (data.Id) {
          data.Id = value.Id;
        }
        context.commit("save", data);

        context.dispatch("loadCouriers");
        return value;
      })
      .catch(
        /* istanbul ignore next */ function(err) {
          errorHelper.showError(err);
        }
      );
  },
  async loadCouriers(context) {
    var api = await services.api;
    context.commit("setLoading", true);
    return api
      .getCouriers()
      .then(function(value) {
        context.commit("setCouriers", value);
      })
      .catch(
        /* istanbul ignore next */ function(err) {
          context.commit("setLoading", false);
          errorHelper.showError(err);
        }
      );
  },
  checkCourierDuplicate(context, formData) {
    return (
      state.couriers.filter(courier => {
        return (
          (courier.Name + "").toLowerCase().trim() ===
            (formData.Name + "").toLowerCase().trim() &&
          (courier.Address.City + "").toLowerCase().trim() ===
            (formData.Address.City + "").toLowerCase().trim() &&
          (courier.Address.Line1 + "").toLowerCase().trim() ===
            (formData.Address.Line1 + "").toLowerCase().trim() &&
          (courier.Address.State + "").toLowerCase().trim() ===
            (formData.Address.State + "").toLowerCase().trim() &&
          (courier.Address.Zip + "").toLowerCase().trim() ===
            (formData.Address.Zip + "").toLowerCase().trim() &&
          courier.Id !== formData.Id
        );
      }).length !== 0
    );
  }
};

const mutations = {
  clearApi(storeState) {
    storeState.apiconnection = null;
  },
  setLoading(storeState, data) {
    storeState.loading = data;
  },
  setError(storeState, data) {
    storeState.loading = false;
    storeState.apiconnection = {
      connected: false,
      message: "Network Error"
    };
  },
  selectCourier(storeState, data) {
    storeState.selected = data;
    storeState.loading = false;
  },
  setCouriers(storeState, data) {
    storeState.couriers = data;
    storeState.loading = false;
  },
  loadServices(storeState, data) {
    storeState.apiconnection = data;
    storeState.loading = false;
  },
  save(storeState, data) {
    let upd = storeState.couriers.find(c => c.Id === data.Id);
    if (upd) {
      Object.assign(upd, data);
    } else {
      storeState.couriers.push(data);
    }
    storeState.selected = null;
    storeState.loading = false;
  }
};

const getters = {
  couriers: storeState => storeState.couriers,
  courier: storeState => storeState.selected,
  apiconnection: storeState => storeState.apiconnection,
  axis: storeState => storeState.couriers.filter(c => c.ApiType === 2),
  eCourier: storeState => storeState.couriers.filter(c => c.ApiType === 1),
  loading: storeState => storeState.loading
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
